import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';

import { TopBannerComponent } from './top-banner.component';

@NgModule({
  declarations: [TopBannerComponent],
  imports: [CommonModule, SlickCarouselModule],
  exports: [TopBannerComponent]
})
export class TopBannerModule { }
